
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useEffect } from "react";
import { AuthForm } from "@/components/auth/AuthForm";
import AdPanel from "@/components/ads/AdPanel";
import { AlphaLoader } from "@/components/ui/alpha-loader";

const Auth = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  // Redirect authenticated users to discovery
  useEffect(() => {
    if (user && !loading) {
      navigate("/discovery");
    }
  }, [user, loading, navigate]);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <>
        <AdPanel />
        <div className="min-h-screen bg-gradient-to-br from-carbon via-carbon to-carbon flex items-center justify-center">
          <AlphaLoader size="large" />
        </div>
      </>
    );
  }

  // Don't render auth form if user is already logged in
  if (user) {
    return null;
  }

  return (
    <>
      <AdPanel />
      <div
      className="min-h-screen flex flex-col items-center justify-center p-4 relative overflow-hidden"
      style={{
        backgroundImage: 'url(/lovable-uploads/512f078d-5b7d-4a2b-b1b5-4ae2374ce514.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Dark overlay for better form readability */}
      <div className="absolute inset-0 bg-black/40 pointer-events-none"></div>
      
        <div className="relative z-10">
          <AuthForm />
        </div>
      </div>
    </>
  );
};

export default Auth;
